<div class="w-screen">
  <div class="flex flex-column">
    <div class="image-container w-full">
      <div class="header-bg w-full">
        <img
          class="fruzty-icon"
          src="../../../../assets/img/flow_selection/fruzty-logo.png"
          alt="fruzty"/>
      </div>
    </div>
  </div>

  <div class="flex flex-column">
    <div class="flex align-items-center pt-3 pl-3 go-back-section">
      <div class="cursor-pointer" (click)="logout()" onkeypress="">
        <i class="pi pi-angle-left text-xs mr-1"></i>
        <span>{{ 'FlowSelectionPage.GoBackText' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="grid">
    <div class="col-1"></div>

    <div class="col-10 flex flex-column justify-content-between lg:px-8">
      <div class="flex flex-column my-3">
        <div>
          <span class="welcome-text">{{ 'FlowSelectionPage.WelcomeToFruztyText' | translate }} </span>
          <span class="username-text welcome-text">{{ user?.contactName }}</span>
          <span class="welcome-text"> / {{ user?.companyName }}</span>
        </div>
        <p class="text-left text-sm line-height-1 mt-2 sm:mt-1">
          {{ 'FlowSelectionPage.ChooseOptionText' | translate }}:
        </p>
      </div>

      <div class="flex flex-column sm:flex-row gap-2 sm:gap-4 xl:gap-8 lg:mt-2">
        <div class="py-2 w-full" (click)="selectMarketplace()" onkeypress="">
          <div class="flow-card flex flex-column justify-content-between h-full">
            <img
              src="../../../../assets/img/flow_selection/marketplace.webp"
              class="flow-img marketplace-img"
              alt="{{ 'FlowSelectionPage.MarketplaceTitle' | translate }}"
            />

            <p class="flow-title px-3">{{ 'FlowSelectionPage.MarketplaceTitle' | translate }}</p>
            <p class="flow-detail px-3">{{ 'FlowSelectionPage.MarketplaceDetailText' | translate }}</p>
          </div>
        </div>

        <div class="py-2 w-full" (click)="selectProgram()" onkeypress="">
          <div class="flow-card flex flex-column justify-content-between h-full">
            <img
              src="../../../../assets/img/flow_selection/program.webp"
              class="flow-img program-img"
              alt="{{ 'FlowSelectionPage.ProgramTitle' | translate }}"
            />

            <p class="flow-title px-3">{{ 'FlowSelectionPage.ProgramTitle' | translate }}</p>
            <p class="flow-detail px-3">{{ 'FlowSelectionPage.ProgramDetailText' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="flex py-2 pb-4 text-right see-both-text align-content-center justify-content-end" onkeypress="">
        <span (click)="selectBoth()" onkeypress="" class="mr-1 cursor-pointer">
          {{ 'FlowSelectionPage.SeeBothText' | translate }}
          <i class="pi pi-angle-right text-xs"></i>
        </span>
      </div>
    </div>

    <div class="col-1"></div>
  </div>
</div>

